import React from 'react'
import { Link } from 'react-router-dom'
import '../reschedule/Reschedule.css'

const Reschedule = () => {
  return (
    <div className='modal-box-sec reschedule-modal-sec'>
        <div className="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <form action="">
                            <div className='form-group'>
                                <label htmlFor="">Date</label>
                                <input type="text" className="form-control" id="" placeholder="DD/MM/YYYY" />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="">Hours</label>
                                <input type="text" className="form-control" id="" placeholder="0" />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="">Start Time</label>
                                <input type="text" className="form-control" id="" placeholder="00:00 " />
                            </div>
                            <div className='btn btn-group align-items-center m-auto d-flex justify-content-center'>
                                <Link rel='stylesheet' to="/" className='btn btn-border'>  Submit</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Reschedule
